<h1 mat-dialog-title>{{ 'properties.detail.mappingTab.viewMapping' | translate  }}</h1>

<mat-dialog-content id="dataToPrint">
  <app-card-spinner [visible]="cardIsLoading" type="zero"></app-card-spinner>
  <div class="row" *ngIf="!cardIsLoading">
    <div class="side-menu col-12 mb-5" id="sideMenu">
      <ng-container *ngIf="mappingIndex && mappingIndex.length">
        <mat-accordion class="mapping-index">
          <ng-container *ngFor="let item of mappingIndex; let i = index;">

            <div class="custom-expansion-panel" *ngIf="checkVisibility(item)"
              [ngClass]="{'openFirstLevel': true === true}">
              <!-- Icon and title accordion -->
              <div class="header-link-wrapper">
                <div class="custom-expansion-panel-header">
                  <!-- <div class="custom-expansion-panel-toggle" [ngClass]="{'openFirstLevel': true === true}">
                  </div> -->
                  <div class="custom-expansion-panel-header-content">
                    <div class="custom-expansion-panel-header-icon-wrapper" *ngIf="item.icon === ''">
                      <mat-icon fontSet="fal" fontIcon="fa-folder" class="mr-3 fa-fw"
                        [ngClass]="{'d-none': item.expanded === true}"></mat-icon>
                      <mat-icon fontSet="fal" fontIcon="fa-folder-open" class="mr-3 fa-fw"
                        [ngClass]="{'d-none': item.expanded === false}"></mat-icon>
                    </div>
                    <div class="custom-expansion-panel-header-icon-wrapper" *ngIf="item.icon !== ''">
                      <div *ngIf="item.title !== 'properties.structures.amianto'">
                        <mat-icon fontSet="fal" fontIcon="{{ item.icon }}" class="mr-3 fa-fw"></mat-icon>
                      </div>
                      <div *ngIf="item.title === 'properties.structures.amianto'" class="amiantoIcon">
                        <svg xmlns="http://www.w3.org/2000/svg" width="54px" height="54px">
                          <text font-weight="50" fill="#ec9451" x="19" y="34" font-size="37">a</text>
                        </svg>
                      </div>
                    </div>
                    <strong>
                      <span *ngIf="lang === 'it' && item.translation">{{ item.translation.it }}</span>
                      <span *ngIf="lang === 'en' && item.translation">{{ item.translation.en }}</span>
                    </strong>
                  </div>
                </div>
              </div>

              <div class="custom-expansion-panel-content">
                <div *ngIf="item.content.length">
                  <div *ngFor="let subItem of item.content">

                    <ng-container *ngIf="subItem.key === 'anagrafica'">
                      <div class="element no-children-element" [ngClass]="{'active': subItem.active}">
                        <span *ngIf="lang === 'it' && subItem.translation">{{ subItem.translation.it }}</span>
                        <span *ngIf="lang === 'en' && subItem.translation">{{ subItem.translation.en }}</span>
                      </div>
                    </ng-container>

                    <ng-container *ngIf="!subItem.hidden && subItem.type === 'link'
                      && subItem.key !== 'anagrafica'
                      && (mappaturaOpen || (!mappaturaOpen && getChildren(subItem.key).length))">
                      <!-- || (!mappaturaOpen && subItem.key === 'anagrafica' ))"> -->
                      <div matBadge="{{ getChildren(subItem.key).length }}" matBadgePosition="above after"
                        matBadgeColor="primary">
                      </div>
                      <div class="custom-expansion-panel-child"
                        *ngIf="mappaturaOpen || (!mappaturaOpen && getChildren(subItem.key).length)">
                        <div class="header-link-wrapper">
                          <div class="custom-expansion-panel-header-second">
                            <!-- <div class="custom-expansion-panel-toggle-child"
                              [ngClass]="{'openSecondLevel': true === true}"></div> -->
                            <div class="custom-expansion-panel-header-content-second">
                              <div class="header-title-wrapper">
                                <span *ngIf="lang === 'it' && subItem.translation">{{ subItem.translation.it }}</span>
                                <span *ngIf="lang === 'en' && subItem.translation">{{ subItem.translation.en }}</span>
                              </div>
                            </div>
                          </div>
                        </div>
                        <ul class="custom-expansion-panel-content-list"
                          [ngClass]="{'openSecondLevel': true === true}">
                          <li *ngFor="let subSubitem of getChildren(subItem.key)"
                            [ngClass]="{'active': (model._id === subSubitem._id && subSubitem.active)}"
                            class="element">
                            <div *ngIf="subSubitem.active">
                              <span *ngIf="subItem.key === 'dipendenti'">{{ subSubitem.nome }}
                                {{ subSubitem.cognome }} </span>
                              <span *ngIf="subItem.key === 'impresePulizia'">{{ subSubitem.nomeDitta }}</span>
                              <!-- <span
                                *ngIf="subItem.key === 'estintori'">{{ 'properties.structures.estintori' | translate }}</span> -->
                              <span
                                *ngIf="subItem.key === 'amianto'">{{ 'properties.structures.amianto' | translate }}</span>
                              <!-- <span
                                *ngIf="subItem.key !== 'dipendenti' && subItem.key !== 'impresePulizia' && subItem.key !== 'estintori'">{{ subSubitem.nome }}</span> -->
                              <span
                                *ngIf="subItem.key !== 'dipendenti' && subItem.key !== 'impresePulizia'">{{ subSubitem.nome }}</span>
                              <div *ngIf="subItem.key === 'fabbricatoAbitativo' && subSubitem.scale">
                                <span *ngFor="let scala of subSubitem.scale">{{ scala.nomeScala}}</span>
                              </div>
                            </div>
                          </li>
                        </ul>
                      </div>

                    </ng-container>
                  </div>
                </div>
              </div>
            </div>

          </ng-container>
        </mat-accordion>
      </ng-container>
    </div> <!-- /.col -->

  </div>
  
</mat-dialog-content>

<div mat-dialog-actions class="mt-5">
  <div class="row w-100">
    <div class="col-6 text-left">
      <a mat-button (click)="onClose()" mat-raised-button mat-default color="warn">
        {{ 'common.cta.close' | translate }}
      </a>
    </div> <!-- /.col -->
    <div class="col-6 text-right">
      <a mat-button (click)="onPrint()" mat-raised-button mat-default color="primary">
        {{ 'common.cta.print' | translate }}
      </a>
    </div> <!-- /.col -->
  </div> <!-- /.row -->
</div>